import '../Scss/swiper.scss';
import '../Scss/style.scss';
import initLightbox from './Utilities/GlobalLightbox';

/**
 * INIT LIGHTBOX
 * It's global and uses .lightbox @DOM
 * Contains Default Parameter to override Labels
 */
initLightbox()
